
/* eslint-disable no-extend-native */

"use strict";

let UniqueLogonDialog = false;

// eslint-disable-next-line no-unused-vars
const UserTimeFormat = function () {
    return EC_Fmt.userTimeFormat;
};
// Trim is not available for Excel, this adds it
if (typeof String.prototype.trim !== "function") {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, "");
    };
}

// eslint-disable-next-line no-unused-vars
function FData(inputObj, dataType, length, required) {
    return EC_Fmt.InputFmt(inputObj, dataType, length, required);
}

// eslint-disable-next-line no-unused-vars
function SiteRequiresSupportEditMemo() {
    // Task 1002952: Exchange Map Field Audits do not have Task ID, always require Task ID when editing Master Shared tables
    return (((UserType === "Support" && !TestDatabase) || ((UserType === "Support" || Distributor.startsWith("Support")) && document.getElementById("DatabaseOfCurrentTableIsMasterShared"))) && SiteIsLive);
}

// eslint-disable-next-line no-unused-vars
function formatCurrency(num) {
    return EC_Fmt.InputFmt(num, ECP.DataType._Currency);
}

function getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] === variable) { return pair[1]; }
    }
    return (false);
}

// eslint-disable-next-line no-unused-vars
function getDistributor() {
    const EncompassID = getQueryVariable("EncompassID");
    if (EncompassID) {
        return EncompassID;
    }
    return getQueryVariable("Distributor");
}

// Task 1185595: Polyfill for requestIdleCallback on Safari
window.requestIdleCallback = window.requestIdleCallback
    || function (cb) {
        const start = Date.now();
        return setTimeout(() => {
            cb({
                didTimeout: false,
                timeRemaining() {
                    return Math.max(0, 50 - (Date.now() - start));
                }
            });
        }, 1);
    };

window.debounce = function (func, wait, ...args) {
    let timer;
    return function () {
        const context = this;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
};

const BC_EWS = function () {
    const me = this;

    this.Instance = 0;
    this.AllowResize = true;
    this.LoadingDelay = 0;
    this.Interval = 60000;
    this.Ctrl = false;
    this.Shift = false;
    this.Fullscreen = false;
    this.FullscreenTimer = null;

    this.HTML5 = true;

    document.addEventListener("DOMContentLoaded", () => {
        // Task 720388: Unable to set password when browser is blocking cookies fix error message to explain problem to user
        if (!navigator.cookieEnabled) {
            ECP.Dialog.Alert("Your browser does not have cookies enabled. Cookies are required to use this site.");
        }

        if (EC_Fmt.Browser === ECP.Browser.Safari) {
            let interval;

            const iOSTextSelectFunction = (event) => {
                const inputElement = event.currentTarget;

                clearInterval(interval);
                interval = setInterval(() => {
                    const ratio = inputElement.scrollWidth / inputElement.value.length;

                    if (inputElement) {
                        const width = inputElement.offsetWidth;

                        if (width < inputElement.scrollWidth) {
                            const x = inputElement.selectionStart;
                            const x2 = inputElement.selectionEnd;
                            const cursorPositionS = x - inputElement.scrollLeft / ratio;
                            const cursorPositionE = x2 - inputElement.scrollLeft / ratio;

                            if (cursorPositionS === cursorPositionE) {
                                if (cursorPositionS < 1) {
                                    inputElement.scrollLeft -= ratio;
                                }
                                if (cursorPositionE > (width / ratio) - 1) {
                                    inputElement.scrollLeft += ratio;
                                }
                            } else {
                                inputElement.setSelectionRange(x, x2);
                            }
                        }
                    } else {
                        clearInterval(interval);
                    }
                }, 100);
            };

            const ClearIntervalIOSTextSelection = () => {
                clearInterval(interval);
            };

            const textInputs = document.querySelectorAll("input[type='text']");
            for (let i = 0; i < textInputs.length; i++) {
                textInputs[i].addEventListener("focus", iOSTextSelectFunction);
                textInputs[i].addEventListener("blur", ClearIntervalIOSTextSelection);
            }
        }
        //  because Users are Not signing up Salesmen for Pre-Delivery Notices because they don't know what word means.Encompass Mobile Alert should link user to Local Invoice View
        if (EC_Fmt.isMobile) {
            const getUrlParam = function (name) {
                const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
                const r = window.location.search.substr(1).match(reg);
                if (r !== null) return unescape(r[2]);
                return null;
            };

            const MobileURL = getUrlParam("MobileURL");
            if (MobileURL) {
                // com.encompass8.encompass://
                window.location = MobileURL;
            }
        }

        if (Date.prototype.getWeekNumber === undefined || Date.prototype.getWeekNumber === null) {
            Date.prototype.getWeekNumber = function () {
                const current = new Date(+this);

                current.setHours(0, 0, 0, 0);
                current.setDate(current.getDate() + 4 - (current.getDay() || 7));

                return Math.ceil((((current - new Date(current.getFullYear(), 0, 1)) / 8.64e7) + 1) / 7);
            };
        }

        window.addEventListener("orientationchange", () => {
            switch (window.orientation) {
                case 0:
                case 180:
                case 90:
                case -90:
                    return false;
            }
            return true;
        });

        const currentTagLinks = document.querySelectorAll("a[href='#']");
        for (let i = 0; i < currentTagLinks.length; i++) {
            currentTagLinks[i].addEventListener("click", () => false);
        }

        me.FixChromeAutocomplete();

        window.addEventListener("resize", me.Resize);
        me.AjaxInputs = {};
        const AjaxInputs = document.querySelectorAll("input[KeyValue][DisplayVal][LimitToList]");
        for (let i = 0; i < AjaxInputs.length; i += 1) {
            const FieldID = AjaxInputs[i].closest("section").getAttribute("FieldID");
            me.AjaxInputs[FieldID] = new ECP.HTML.AjaxInput(AjaxInputs[i]);
        }

        me.Ready();
        me.Resize();

        // Task 569618

        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible" && !IsImpersonateUser) {
                this.VerifySession(() => {
                    const LogonDialog = document.querySelector(".ecp-Logon-dialog");
                    if (LogonDialog) {
                        LogonDialog.style.display = "none";
                    }
                    const LogonDialogMask = document.querySelector("div.ews-dialog-modal");
                    if (LogonDialogMask) {
                        LogonDialogMask.style.display = "none";
                    }
                });
            }
        }, false);

        if (window.self === window.top) {
            me.StartPageTimer();
        }

        // Task 713025: Adding PWA functionality for ECP
        // Firefox does not handle service workers correctly if the user is using the default 'keep cookies until I close firefox' setting - https://bugzilla.mozilla.org/show_bug.cgi?id=1413615
        if ("serviceWorker" in navigator && EC_Fmt.Browser !== ECP.Browser.Firefox) {
            if (ReleasedCode) {
                navigator.serviceWorker.register("ServiceWorker.min.js").catch(() => { });
            } else {
                navigator.serviceWorker.register("ServiceWorker.js").catch(() => { });
            }
        }
    });
};

BC_EWS.prototype.Alert = (message) => {
    ECP.Dialog.Alert(message);
};

BC_EWS.prototype.Confirm = function (message, confirmed, canceled) {
    ECP.Dialog.ShowDialog("Confirm", `<table style=width:100%;height:100% class=NoPadding><tr><td id=ews-confirm-message style=text-align:center>${message}</td></tr></table>`, {
        width: 450,
        height: 200,
        cancelButtonTitle: "Cancel",
        confirmButtonTitle: "OK",
        cancelButtonAction() {
            if (canceled) {
                canceled();
            }
        },
        confirmButtonAction(dialog) {
            ECP.Dialog.CloseDialog(dialog);

            if (confirmed) {
                confirmed();
            }
        }
    });
};

BC_EWS.prototype.EncryptLogin = function (form) {
    const me = this;

    // Task 429466
    if (navigator.geolocation) {
        requestAnimationFrame(() => {
            navigator.geolocation.getCurrentPosition(
                (p) => {
                    const LogonForm = document.getElementById("LogonForm");
                    if (LogonForm) {
                        LogonForm.querySelector("#Latitude").value = p.coords.latitude;
                        LogonForm.querySelector("#Longitude").value = p.coords.longitude;
                    }
                }
            );
        });
    }
    if (typeof form === "string") {
        form = document.querySelector(form);
    }

    if (form instanceof HTMLElement) {
        form.action = "Home";
        form.addEventListener("submit", async (event) => {
            event.preventDefault();
            me.EncryptLoginDivert(event.currentTarget);
            // Task 707913: DevOps: Convert DashboardItemType to DashboardWidget.
            // Task 1100879: Long running query of Logon_Guest
            if (!EC_Fmt.isNull(form.querySelector("#Theme").value)) {
                const myRequest = new ECP.EC_Request("Logon_Guest");
                myRequest.SetAPIToken("33c9305a94a58896fd87f0efd2411380");
                myRequest.AddRequestVariable("Style", form.querySelector("#Style").value, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Theme", form.querySelector("#Theme").value, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Latitude", form.querySelector("#Latitude").value, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Longitude", form.querySelector("#Longitude").value, ECP.EC_Verb.Post);
                ECP.Dialog.ShowLoading("Logging On...");
                const result = await myRequest.Submit();

                if (result.status === "requireMFA") {
                    ECP.Dialog.HideLoading();
                    const mfaResult = await EWS.CheckMFAStatus(result.message, result.type, result.token);
                    if (mfaResult === "True") {
                        result.status = "success";
                    } else {
                        result.status = "fail";
                        result.message = mfaResult;
                    }
                }

                if (result.status === "success" || result.status === "expired") {
                    // Task 1033298: Adding Google Analytics as a default feature of dashboards
                    gtag("event", "relogin", { status: result.status });
                    const DestURL = form.querySelector("#DestURL").value;
                    // Task 1010255: Redirect users to the URL in setting 38 just before the login cookies are set- consistent URL when logged in for all users
                    if (EC_Fmt.isNull(result.redirectURL) || result.redirectURL.indexOf(window.location.hostname) !== -1) {
                        if (!EC_Fmt.isNull(DestURL)) {
                            try {
                                const parsedUrl = new URL(DestURL);
                                window.location.href = parsedUrl.pathname;
                            } catch (e) {
                                window.location.href = DestURL;
                            }
                        } else {
                            window.location.href = "Home";
                        }
                    } else {
                        let postURL = result.redirectURL;
                        if (!EC_Fmt.isNull(DestURL)) {
                            postURL += "&DestURL=";
                            postURL += encodeURIComponent(DestURL);
                        }
                        const tempForm = document.createElement("form");
                        tempForm.id = 38;
                        tempForm.action = postURL;
                        tempForm.method = "post";
                        tempForm.style.display = "none";
                        const opt = document.createElement("input");
                        opt.type = "hidden";
                        opt.name = "EncompassSessionID";
                        opt.value = result.sessionID;
                        tempForm.appendChild(opt);
                        document.body.appendChild(tempForm);
                        tempForm.submit();
                    }
                } else if (result.message.indexOf("2|") === 0) {
                    form.style.display = "block";
                    const loginDialogData = await DisplayLogon(result.message);
                    // Task 1118614: Unable to log in with user with multiple roles on desktop
                    ECP.Dialog.ShowDialog("Logon", loginDialogData, { height: "auto", disableButtons: true });
                    ECP.Dialog.HideLoading();
                } else {
                    if (!EC_Fmt.isNull(document.getElementById("ews-login-field-error"))) {
                        document.getElementById("ews-login-field-error").parentNode.removeChild(document.getElementById("ews-login-field-error"));
                    }
                    const errorsMessage = document.getElementById("errormessage");
                    // Task 1035074: Replace login error message with <ecp-sectionmessage> component
                    if (result.message.indexOf("<br>") === 0) {
                        errorsMessage.innerHTML = `<ecp-sectionmessage class=ecp-logon-tips type=error>${result.message.slice(4)}</ecp-sectionmessage>`;
                    } else {
                        errorsMessage.innerHTML = `<ecp-sectionmessage class=ecp-logon-tips type=error>${result.message}</ecp-sectionmessage>`;
                    }
                    // Task 1016513: User John Akins unable to login to Encompass on the server and Encompass Mobile'ReferenceError: Can't find variable: errorsmessage'
                    document.getElementById("errormessage").firstChild.firstChild.style.minHeight = 0;
                    // Task 839924: Site Login: When username/password is incorrect focus is put in Password box instead of Username
                    document.getElementById("ews-login-password").focus();
                    // Task 983319: Require OAuth login on Roles
                    if (result.message === "Users in this role are required to Log In with OAuth.") {
                        const LogonForm = document.getElementById("LogonForm");
                        if (LogonForm) {
                            LogonForm.style.display = "none";
                        }
                        const resetPasswordBtn = document.getElementById("reset-pwd-btn");
                        if (resetPasswordBtn) {
                            resetPasswordBtn.style.display = "none";
                        }
                    }
                    ECP.Dialog.HideLoading();
                }
            }
            return false;
        });
    }
};

// eslint-disable-next-line no-unused-vars
const DES = () => {
    const form = document.getElementById("LoginForm");

    let username = form.querySelector("#UserNameHidden").value;
    let support = false;

    username = username.toLowerCase().trim();

    if (username.endsWith("$")) {
        username = username.slice(0, -1);
        support = true;
    }
    username = EC_Fmt.MD5(username);

    if (support) {
        username += "$";
    }

    form.querySelector("#Style").value = username;
    form.submit();
};

BC_EWS.prototype.EncryptLoginDivert = (form) => {
    // Task 1080985: The timeout login box/page does not work
    const usernameField = form.querySelector("#ews-login-username");
    const passwordField = form.querySelector("#ews-login-password");
    let username = usernameField.value;
    let password = passwordField.value;

    passwordField.value = "";

    let support = false;
    username = username.toLowerCase().trim();

    if (username.endsWith("$")) {
        username = username.slice(0, -1);
        support = true;
    }

    const isEmail = EC_Fmt.isEmail(username);

    username = EC_Fmt.MD5(username);
    if (!EC_Fmt.isNull(password)) {
        password = EC_Fmt.MD5(password);
    }
    if (support) {
        username += "$";
    }

    if (isEmail) {
        username = `@${username}`;
    }

    form.querySelector("#Style").value = username;
    form.querySelector("#Theme").value = password;

    return form;
};

BC_EWS.prototype.FixChromeAutocomplete = () => {
    if (EC_Fmt.Browser === ECP.Browser.Chrome && parseInt(EC_Fmt.BrowserVersion) >= 41) {
        requestAnimationFrame(() => {
            const textInputs = document.querySelectorAll("input[type='text']");
            for (let i = 0, len = textInputs.length; i < len; i++) {
                textInputs[i].autocomplete = "off";
            }
        });
    }
};

BC_EWS.prototype.FormData = () => new FormData();

BC_EWS.prototype.IsFloat = value => EC_Fmt.isNumber(value);

BC_EWS.prototype.Selector = (value) => {
    if (value && value !== "") {
        return value.toString().replace(/(:|\.|\[|\]|\^|\/)/g, "\\$1");
    }
    return "";
};

BC_EWS.prototype.ShowLoading = (delay, cover, loadingText, hidingFromBackForward) => {
    if (window.jQuery && cover instanceof window.jQuery && cover.length > 0) {
        let mySelector = cover.selector;
        if (EC_Fmt.isNull(mySelector)) {
            mySelector = EC_Fmt.MD5(new Date().toString());
            cover.addClass(mySelector);
            mySelector = `[class*='${mySelector}']`;
        }
        ECP.Dialog.ShowLoading(loadingText, mySelector);
    } else if (cover instanceof HTMLElement) {
        let mySelector = EC_Fmt.MD5(new Date().toString());
        cover.classList.add(mySelector);
        mySelector = `[class*='${mySelector}']`;
        ECP.Dialog.ShowLoading(loadingText, mySelector);
    } else {
        ECP.Dialog.ShowLoading(loadingText);
    }
    if (hidingFromBackForward) {
        const hideTimer = setInterval(() => {
            if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
                EWS.HideLoading();

                clearInterval(hideTimer);
            }
        }, 500);
    }
};

BC_EWS.prototype.StartPageTimer = function () {
    const me = this;

    this.PageInterval = window.setInterval(() => {
        me.PageTimer();
    }, this.Interval);
};

BC_EWS.prototype.StopPageTimer = function () {
    window.clearInterval(this.PageInterval);
};

BC_EWS.prototype.HideLoading = () => {
    ECP.Dialog.HideLoading();
};

BC_EWS.prototype.Load = function (script, callback) {
    const me = this;
    if (EC_Fmt.isNull(me.LoadedScripts)) {
        me.LoadedScripts = [];
    }
    // Task 388737

    if (me.LoadedScripts.indexOf(script) < 0) {
        const jsScript = document.createElement("script");
        jsScript.type = "text/javascript";
        jsScript.src = script;
        jsScript.async = true;
        jsScript.onreadystatechange = function () {
            me.LoadedScripts.push(script);

            if (!EC_Fmt.isNull(callback)) {
                requestIdleCallback(() => {
                    callback();
                }, { timeout: 250 });
            }
        };

        jsScript.onload = jsScript.onreadystatechange;

        document.getElementsByTagName("head")[0].appendChild(jsScript);
    } else if (!EC_Fmt.isNull(callback)) {
        callback();
    }
};

BC_EWS.prototype.Login = async function (callback) {
    const me = this;

    let loginDialog = document.querySelector(".ecp-Logon-dialog");
    if (loginDialog) {
        loginDialog.style.display = "block";
    } else if (!UniqueLogonDialog) {
        UniqueLogonDialog = true;
        // Task 628953: API Token for Encompass_DevOps_Public located in multiple.js files.
        const myRequest = new ECP.EC_Request("Dialog_Session_Expires_Logon_Guest");
        myRequest.AddRequestVariable("Mobile", EC_Fmt.isMobile);
        myRequest.SetAPIToken("33c9305a94a58896fd87f0efd2411380");

        const myResult = await myRequest.Submit();
        // Task 1068633: Two login dialogs appear after session times out
        loginDialog = document.querySelector(".ecp-Logon-dialog");
        if (loginDialog) {
            loginDialog.style.display = "block";
        } else {
            const Dialog = ECP.Dialog.ShowDialog("Log in", myResult.content, {
                disableResize: true,
                width: 370,
                // Task 1061314: Login dialog contains a scroll bar if there are OAuth sign in options- Making the dialog slightly taller
                height: EC_Fmt.isMobile ? "auto" : 390,
                barPosition: "top",
                cancelButtonTitle: "Cancel",
                confirmButtonTitle: "Log in",
                confirmButtonAction(dialog) {
                    EC_Fmt.TriggerEvent(dialog.querySelector("#ews-login-form"), "submit");
                }
            });

            Dialog.classList.add("ecp-Logon-dialog");
            UniqueLogonDialog = false;
            // Task 643544: Timeout login popup redirects the user to the login page
            const otherLogin = Dialog.querySelector(".other-login");
            const oAuthTitle = Dialog.querySelector(".o-auth-title");
            if (otherLogin) {
                otherLogin.style.position = "absolute";
                otherLogin.style.top = "140px";
                oAuthTitle.style.margin = "20px 0 13px 0";
            }

            // Task 1123508: Incorrect dialog button padding
            if (EC_Fmt.isMobile) {
                if (otherLogin) {
                    otherLogin.setAttribute("style", "");
                    oAuthTitle.setAttribute("style", "margin-top:10%");
                    Dialog.querySelector("#reset-pwd-btn").setAttribute("style", "line-height:inherit;text-decoration:auto");
                }
            }

            const loginForm = Dialog.querySelector("#ews-login-form");

            loginForm.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    EC_Fmt.TriggerEvent(loginForm, "submit");
                }
            });
            const usernameInput = Dialog.querySelector("#ews-login-username");
            usernameInput.focus();
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (p) => {
                        if (loginForm) {
                            loginForm.querySelector("#Latitude").value = p.coords.latitude;
                            loginForm.querySelector("#Longitude").value = p.coords.longitude;
                        }
                    }
                );
            }
            usernameInput.value = "";
            loginForm.querySelector("#ews-login-password").value = "";

            loginForm.querySelector("#Style").value = "";
            loginForm.querySelector("#Theme").value = "";

            ECP.Dialog.HideLoading();

            let working = false;

            loginForm.addEventListener("submit", (event) => {
                event.preventDefault();

                if (!working) {
                    working = true;

                    const LogonForm = me.EncryptLoginDivert(loginForm);
                    LogonForm.style.display = "none";

                    setTimeout(async () => {
                        ECP.Dialog.ShowLoading("Logging Back On...");
                        // Task 716545: Logging in through the 'login dialog' does not record the user's longitude and latitude
                        const myLoginRequest = new ECP.EC_Request("Logon_Guest");
                        myLoginRequest.SetAPIToken("33c9305a94a58896fd87f0efd2411380");
                        myLoginRequest.AddRequestVariable("Style", LogonForm.querySelector("#Style").value, ECP.EC_Verb.Post);
                        myLoginRequest.AddRequestVariable("Theme", LogonForm.querySelector("#Theme").value, ECP.EC_Verb.Post);
                        myLoginRequest.AddRequestVariable("Latitude", LogonForm.querySelector("#Latitude").value, ECP.EC_Verb.Post);
                        myLoginRequest.AddRequestVariable("Longitude", LogonForm.querySelector("#Longitude").value, ECP.EC_Verb.Post);
                        const result = await myLoginRequest.Submit();
                        if (result.status === "requireMFA") {
                            ECP.Dialog.HideLoading();
                            const mfaResult = await EWS.CheckMFAStatus(result.message, result.type, result.token);
                            if (mfaResult === "True") {
                                result.status = "success";
                            } else {
                                result.status = "fail";
                                result.message = mfaResult;
                            }
                        }

                        if (result.status === "success") {
                            ECP.Dialog.CloseDialog(Dialog);
                            me.StartPageTimer();
                            me.ReLogin();

                            if (!EC_Fmt.isNull(callback)) {
                                ECP.Dialog.HideLoading();
                                callback();
                            }
                        } else if (result.status === "expired") {
                            window.location.href = `../aspx1/Home?DashboardID=168087`;
                        } else if (result.message.indexOf("2|") === 0) {
                            ECP.Dialog.CloseDialog(Dialog);
                            LogonForm.style.display = "block";
                            const loginDialogData = await DisplayLogon(result.message);
                            ECP.Dialog.ShowDialog("Logon", loginDialogData, { height: 345, disableButtons: true });
                        } else {
                            ECP.Dialog.Alert(result.message);

                            ECP.Dialog.HideLoading();
                            LogonForm.style.display = "block";

                            working = false;
                        }
                        ECP.Dialog.HideLoading();
                        LogonForm.style.display = "block";
                        if (result.status === "success" && !EC_Fmt.isMobile) {
                            // Task 758982: Remind Me is replaced by Username@EncompassID when Session Expired
                            const labelButtons = document.getElementById("UserMenuToggle");
                            if (!EC_Fmt.isNull(labelButtons)) {
                                labelButtons.innerHTML = result.username;
                            }
                        }
                    }, 250);
                }
                return false;
            });
        }
    }
};

BC_EWS.prototype.PageTimer = function (callback) {
    if (callback) {
        const current = this.OnPageTimer;

        if (typeof this.OnPageTimer !== "function") {
            this.OnPageTimer = callback;
        } else {
            this.OnPageTimer = function (EWS) {
                if (current) {
                    current(EWS);
                }

                callback(EWS);
            };
        }
    } else {
        if (!IsImpersonateUser) {
            this.VerifySession();
        }
        if (this.OnPageTimer) {
            this.OnPageTimer(this);
        }
    }
};

BC_EWS.prototype.Post = (html) => {
    const form = EC_Fmt.HtmlStrToElement(html);
    form.style.display = "none";
    document.body.appendChild(form);
    form.submit();
};

BC_EWS.prototype.EwsIsReady = false;

BC_EWS.prototype.Ready = function (callback) {
    if (callback) {
        if (this.EwsIsReady) {
            callback(EWS);
        } else {
            const current = this.OnReady;

            this.OnReady = function (EWS) {
                EWS.EwsIsReady = true;

                if (current) {
                    current(EWS);
                }
                callback(EWS);
            };
        }
    } else if (this.OnReady) {
        this.OnReady(this);
    }
};

BC_EWS.prototype.ReLogin = function (callback) {
    if (callback) {
        const current = this.OnReLogin;

        if (typeof this.OnReLogin !== "function") {
            this.OnReLogin = callback;
        } else {
            this.OnReLogin = function (EWS) {
                if (current) {
                    current(EWS);
                }

                callback(EWS);
            };
        }
    } else if (this.OnReLogin) {
        this.OnReLogin(this);
    }
};

BC_EWS.prototype.TipsPosition = (Container) => {
    const dashboardTipsContainer = Container.querySelector(".ews-dashboard-tips-container");
    if (dashboardTipsContainer) {
        dashboardTipsContainer.addEventListener("mouseover", (event) => {
            const BoundingRect = event.currentTarget.getBoundingClientRect();

            const dashboardTipsDescription = event.currentTarget.querySelector(".ews-dashboard-tips-description");
            dashboardTipsDescription.style.top = (BoundingRect.top + 23);
            dashboardTipsDescription.style.left = (BoundingRect.left - 20);
            dashboardTipsDescription.style.display = "block";

            event.currentTarget.querySelector(".ews-icon-info-label").classList.add("on");
        });

        const nonFocusFunc = (event) => {
            event.currentTarget.querySelector(".ews-dashboard-tips-description").style.display = "none";
            event.currentTarget.querySelector(".ews-icon-info-label").classList.remove("on");
        };

        dashboardTipsContainer.addEventListener("mouseout", nonFocusFunc);
        dashboardTipsContainer.addEventListener("mousewheel", nonFocusFunc);
    }
};

BC_EWS.prototype.Resize = function (callback) {
    if (callback) {
        const current = this.OnResize;

        if (typeof this.OnResize !== "function") {
            this.OnResize = callback;
        } else {
            this.OnResize = function (EWS) {
                if (current) {
                    current(EWS);
                }

                callback(EWS);
            };
        }
    } else if (!EC_Fmt.isMobile && this.AllowResize) {
        // Task 379194
        if (EC_Fmt.Browser === ECP.Browser.Edge) {
            if (this.Fullscreen) {
                this.ExitFullscreen();
            }
        }

        if (this.OnResize) {
            this.OnResize(this);
        }
    }
};

BC_EWS.prototype.VerifySession = function (successCallback, postBack, errorCallback, failCallback) {
    const me = this;

    // Task 686528: Add 'No internet connection' prompt when EC_Request in the SDK tries to call to the server without an internet connection
    if (!navigator.onLine) {
        if (!BC_EWS.NoInternetDialog || !EC_Fmt.isVisible(BC_EWS.NoInternetDialog)) {
            // Task 713357: Javascript error: Failed to execute 'removeChild' on 'Node': parameter 1 is not of type 'Node'.
            clearInterval(BC_EWS.NoInternetDialogInterval);
            BC_EWS.NoInternetDialog = ECP.Dialog.Alert("No Internet Connection");
            BC_EWS.NoInternetDialogInterval = setInterval(() => {
                if (navigator.onLine) {
                    if (BC_EWS.NoInternetDialog) {
                        BC_EWS.NoInternetDialog.remove();
                    }
                    BC_EWS.NoInternetDialog = undefined;
                    clearInterval(BC_EWS.NoInternetDialogInterval);
                }
            }, 1000);
        }
        if (!EC_Fmt.isNull(failCallback)) {
            failCallback("No Internet Connection");
        }
    } else {
        let AvailableLogonDialog = false;
        const loginDialog = document.querySelector(".ecp-Logon-dialog");
        if (loginDialog) {
            AvailableLogonDialog = true;
            if (loginDialog.style.display === "none") {
                AvailableLogonDialog = false;
            }
        }
        const localTimeStamp = new Date().getTime();
        const expireTimestamp = EC_Fmt.Null2ZeroInt(EC_Fmt.GetCookie("ExpireTime"));

        if (localTimeStamp > expireTimestamp || (localTimeStamp <= expireTimestamp && AvailableLogonDialog) || EC_Fmt.GetCookie("Guest") === "True") {
            // Task 660080: Pre-delivery, post-delivery Invoice: When a customer opens an Invoice via Invoice Link, user is getting prompted to log in.
            fetch(`api?APICommand=VerifySession_Guest&IsImpersonateUser=${IsImpersonateUser}&EncompassID=${Distributor}&APIToken=33c9305a94a58896fd87f0efd2411380`, {
                credentials: "same-origin"
            }).then(response => response.json()).then((result) => {
                if (!result.valid) {
                    if (!postBack) {
                        me.StopPageTimer();

                        if (UserType !== "Guest") {
                            // Task 603368: When Session Cookies expire, EWS.VerifySession fails to validate Session correctly.
                            if (EC_Fmt.Null2EmptyStr(EC_Fmt.GetCookie("EncompassID")) !== "") {
                                me.Login(successCallback);
                            }
                            me.VerifySessionFail();
                        }
                    } else if (!EC_Fmt.isNull(failCallback)) {
                        failCallback(result);
                    }
                } else if (!EC_Fmt.isNull(successCallback)) {
                    successCallback();
                }
            }).catch(() => {
                // Task 346363
                if (!EC_Fmt.isNull(errorCallback)) {
                    errorCallback();
                }
            });
        } else if (localTimeStamp <= expireTimestamp && !AvailableLogonDialog && UserType !== "Guest" && !EC_Fmt.isNull(successCallback)) {
            successCallback();
        }
    }
};

// Task 442006: Add ability to 'barge' onto an ongoing call in Encompass Voice
BC_EWS.prototype.bargeCall = function (CallID, UserID) {
    const data = new FormData();
    data.append("CallID", CallID);
    data.append("AuthenticationID", AuthenticationID);
    data.append("UserID", UserID);
    // Task 688375: Pallet IDs are not being added in incremental packages
    fetch("api?APICommand=SalesComm_VoiceControls_Barge", {
        credentials: "same-origin",
        method: "POST",
        body: data
    }).then(response => response.json()).then((results) => {
        if (results.status !== "success") {
            ECP.Dialog.Alert(results.message);
            // Task 631558: Unable to Barge phone-calls when clicking Barge. User is receiving a JavaScript Error: UnknownFile (0) - Error in promise - ReferenceError: autoAccept is not defined error.
        }
    });
};

// Task 610406: Call fails when I click the phone number on a task.
BC_EWS.prototype.Click2Call = function (Identity, ToNumber, UserID, TaskID) {
    // Task 918041: Sales Center- Outbound call had voicemail message playing when person answers
    if (!Identity) {
        if (AuthenticationID) {
            Identity = `client:${AuthenticationID}`;
        } else {
            ECP.Dialog.Alert("AuthenticationID is empty.");
            return;
        }
    }
    ToNumber = ToNumber.toLowerCase();

    if (ToNumber === Identity) {
        ECP.Dialog.Alert("You may not call yourself");
    } else {
        const request = function () {
            window.localStorage.setItem("autoAccept", "true");
            const myRequest = new ECP.EC_Request(`SalesComm_VoiceControls_NewOutBoundCall`);
            myRequest.SetReturnType(ECP.EC_ReturnType.Text);
            myRequest.AddRequestVariable("Identity", Identity, ECP.EC_Verb.Post);
            myRequest.AddRequestVariable("ToNumber", ToNumber, ECP.EC_Verb.Post);
            myRequest.AddRequestVariable("ToUserID", UserID, ECP.EC_Verb.Post);
            myRequest.AddRequestVariable("TaskID", TaskID, ECP.EC_Verb.Post);
            myRequest.Submit();

            setTimeout(() => {
                window.localStorage.setItem("autoAccept", "false");
            }, 5000);
        };

        const temp = window.localStorage.getItem("ActiveDialerCount");
        let count = 0;
        if (temp) {
            count = parseInt(temp);
        }

        if (count > 0) {
            request();
            if (Settings.DashboardID !== 138848) {
                ECP.Dialog.Alert("The call is placed in Call Manager dashboard.");
            }
        } else {
            window.open("Home?DashboardID=138848").focus();

            setTimeout(() => {
                request();
            }, 5000);
        }
    }
};

BC_EWS.prototype.VerifySessionFail = function (callback) {
    if (callback) {
        const current = this.OnVerifySessionFail;

        if (typeof this.OnVerifySessionFail !== "function") {
            this.OnVerifySessionFail = callback;
        } else {
            this.OnVerifySessionFail = function (EWS) {
                if (current) {
                    current(EWS);
                }

                callback(EWS);
            };
        }
    } else if (this.OnVerifySessionFail) {
        this.OnVerifySessionFail(this);
    }
};

BC_EWS.prototype.EnterFullscreen = function (callback, refresh) {
    // Task 1033298: Adding Google Analytics as a default feature of dashboards
    gtag("event", "enterFullscreen");
    const me = this;
    const body = document.body;
    // Task 644280: In ECP 20.01, Run Test Case 3931 fail
    const FullscreenEnabled = (body.requestFullscreen || body.webkitRequestFullscreen || body.mozRequestFullScreen);

    if (FullscreenEnabled && body) {
        const FullScreenChangeFunction = () => {
            if (me.Fullscreen) {
                me.ExitFullscreen();
            } else {
                me.Fullscreen = true;
            }
        };

        document.addEventListener("fullscreenchange", FullScreenChangeFunction);
        document.addEventListener("webkitfullscreenchange", FullScreenChangeFunction);
        document.addEventListener("mozfullscreenchange", FullScreenChangeFunction);

        body.classList.add("ews-fullscreen");

        if (body.requestFullscreen) {
            body.requestFullscreen();
        } else if (body.webkitRequestFullscreen) {
            body.webkitRequestFullscreen();
        } else if (body.mozRequestFullScreen) {
            body.mozRequestFullScreen();
        }
        window.addEventListener("beforeunload", () => {
            if (me.Fullscreen) {
                me.ExitFullscreen();
            }
        });

        if (!EC_Fmt.isNull(callback) && EC_Fmt.isNumber(refresh) && refresh > 0) {
            if (refresh < 15000) {
                refresh = 15000;
            }
            this.FullscreenTimer = setInterval(() => {
                callback();
            }, refresh);
        }
    }
};

BC_EWS.prototype.ExitFullscreen = function () {
    const me = this;
    const FullscreenEnabled = (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement);

    if (FullscreenEnabled) {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        }
    }

    if (me.Fullscreen) {
        me.Fullscreen = false;
        clearTimeout(me.FullscreenTimer);

        window.location.href = "Home?LogOnType=LogOff";
    }
};

BC_EWS.prototype.StopBubble = (event) => {
    event.stopPropagation();
    return false;
};

BC_EWS.prototype.ShowMobileMenuMask = () => {
    const MobileBodyWrap = document.getElementById("MobileBodyWrap");
    if (MobileBodyWrap) {
        const menuMask = document.createElement("div");
        menuMask.classList.add("menu-mask", "Hideable");
        MobileBodyWrap.appendChild(menuMask);
    }
};

// Task 479843: Move call manager info/availability from User Field Audit to the TimeClockActivities
BC_EWS.prototype.SetStatus = function (Availability, TimeClockActivity, Memo) {
    const data = new FormData();
    const me = this;
    me.status = Availability;

    data.append("Availability", Availability);
    data.append("TimeClockActivity", TimeClockActivity);
    data.append("Memo", Memo);

    // Task 688375: Pallet IDs are not being added in incremental packages
    fetch("api?APICommand=SalesComm_VoiceControls_UpdateStatus", {
        credentials: "same-origin",
        method: "POST",
        body: data
    }).then(response => response.json()).then((result) => {
        if (result.status === "success") {
            // Task 957461: Call Status always says 'Unavailable' in collapsed user menu, even when actual status is Available or Busy
            const TimeClockActivityDisplayText = document.getElementById("TimeClockActivityDisplayText");
            if (result.Text && TimeClockActivityDisplayText) {
                TimeClockActivityDisplayText.textContent = result.Text;
            }

            const TimeClockActivityIcon = document.getElementById("TimeClockActivityIcon");
            if (result.Color && TimeClockActivityIcon) {
                TimeClockActivityIcon.style.color = result.Color;
            }

            // Task 961259: Dialer Status not updating right away
            const PhoneIcon = document.querySelector("div[name=CallManager] .ews-icon-phone");
            if (PhoneIcon && result.Color) {
                PhoneIcon.style.color = result.Color;
            }
        } else {
            EWS.Alert("Could not update status.");
        }
    });
};

BC_EWS.prototype.ShowStatus = function () {
    const myRequest = new ECP.EC_Request("Dialog_StatusMenu");
    myRequest.Submit().then((result) => {
        const cancel = `<div id=ews-confirm-cancel-button class=ews-dialog-button>${result.cancel}</div>`;
        const dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
            width: 450,
            height: 200,
            cancelButtonTitle: cancel
        });
        dialog.querySelector(".ecp-dialog-confirm-button").remove();
    });
};

BC_EWS.prototype.ClearMenuCache = (callback) => {
    fetch("api?APICommand=ResetMenuCache", {
        credentials: "same-origin"
    }).then(() => {
        if (!EC_Fmt.isNull(callback)) {
            callback();
        }
    });
};

// Task 637648: ReleaseNotes.HowToUse no longer shows full text editor. Unable to view all text in the field.
BC_EWS.prototype.InitControl = function (container) {
    EWS.Input.Init(container);

    const ajaxInputs = container.querySelectorAll("input[KeyValue][DisplayVal][LimitToList]");

    for (let i = 0; i < ajaxInputs.length; i++) {
        const FieldID = ajaxInputs[i].closest("section").getAttribute("FieldID");
        this.AjaxInputs[FieldID] = new ECP.HTML.AjaxInput(ajaxInputs[i]);
    }
};

BC_EWS.prototype.CheckMFAStatus = async function (message, type, MFAToken) {
    const myRequest = new ECP.EC_Request("MFA_CheckStatus");
    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
    myRequest.SetAPIToken("c4927d3841234af6f81fbeb219afbf44");
    myRequest.AddRequestVariable("MFAToken", MFAToken, ECP.EC_Verb.Post);

    // a. A login request has been pushed to your primary device.
    // b. A message with a verification link has been sent to your email.
    // Task 1183470: Design system compliance: 2FA email
    let retryDialog = null;
    const dialog = ECP.Dialog.ShowDialog(
        "Verify with Encompass Mobile",
        message,
        {
            barPosition: "top",
            footer: "<div><ecp-btn class=use-authenticator-code type=secondary>Use Authenticator Code instead</ecp-btn><ecp-btn class=no-login-request type=primary>Didn't Get a Login Request?</ecp-btn></div>"
        }
    );

    dialog.querySelector(".use-authenticator-code").addEventListener("click", () => {
        dialog.style.display = "none";
        const AuthenticatorDialog = ECP.Dialog.ShowDialog(
            "Verify with Authenticator Code",
            `<div>`
            + `<p>Enter the code displayed in the Authenticator App on your phone.</p>`
            + `<p style="margin-top:1rem"><div><ecp-input class=totp-code-input type=number placeholder=XXXXXX></ecp-input></div></p>`
            + `</div>`,
            {
                barPosition: "top",
                width: 380,
                height: 240,
                disableResize: true,
                cancelButtonTitle: "Cancel",
                cancelButtonAction: () => {
                    dialog.style.display = "block";
                },
                confirmButtonAction: async () => {
                    await Verify_TimeBasedOneTimePassword();
                }
            }
        );
        const confirmBtn = AuthenticatorDialog.querySelector(".ecp-dialog-confirm-button");
        confirmBtn.disabled = true;

        const codeInput = AuthenticatorDialog.querySelector(".totp-code-input");
        codeInput.focus();
        codeInput.addEventListener("input", () => {
            const code = EC_Fmt.Left(codeInput.value, 6);
            codeInput.value = code;
            confirmBtn.disabled = code.length !== 6;
            if (code.length === 6) {
                Verify_TimeBasedOneTimePassword();
            }
        });

        async function Verify_TimeBasedOneTimePassword() {
            ECP.Dialog.ShowLoading();
            const myAuthRequest = new ECP.EC_Request("Verify_TimeBasedOneTimePassword");
            myAuthRequest.SetAPIToken("c4927d3841234af6f81fbeb219afbf44");
            myAuthRequest.AddRequestVariable("MFAToken", MFAToken, ECP.EC_Verb.Post);
            myAuthRequest.AddRequestVariable("Code", codeInput.value, ECP.EC_Verb.Post);
            try {
                const response = await myAuthRequest.Submit();
                if (response.Success) {
                    AuthenticatorDialog.style.display = "none";
                    ECP.HTML.Snackbar("Success", "Success");
                } else {
                    ECP.HTML.Snackbar(response.Error, "Error");
                    ECP.Dialog.HideLoading();
                }
            } catch (error) {
                ECP.HTML.Snackbar(error, "Error");
                ECP.Dialog.HideLoading();
            }
        }
    });

    dialog.querySelector(".no-login-request").addEventListener("click", () => {
        dialog.style.display = "none";
        retryDialog = ECP.Dialog.ShowDialog(
            "Didn't Get a Login Request?",
            `<div style=display:flex;flex-direction:column;align-items:center>${type === "loginRequest" ? `<ecp-btn class=re-push id=push2em width=310px>Re-push a login request to my primary device</ecp-btn>` : ""
            }<ecp-btn class=send-mail id=push2email width=310px>Send me an email with a verification link</ecp-btn></div>`,
            {
                barPosition: "top",
                width: 380,
                height: 180,
                disableButtons: true,
                disableResize: true,
                cancelButtonAction: () => {
                    dialog.style.display = "block";
                }
            }
        );
        const retryFunction = async (retryType) => {
            ECP.Dialog.ShowLoading();
            if (retryDialog) {
                ECP.Dialog.CloseDialog(retryDialog);
            }
            const myRetryRequest = new ECP.EC_Request("MFA_PushLoginRequest");
            myRetryRequest.SetReturnType(ECP.EC_ReturnType.Text);
            myRetryRequest.SetAPIToken("c4927d3841234af6f81fbeb219afbf44");
            myRetryRequest.AddRequestVariable("MFAToken", MFAToken, ECP.EC_Verb.Post);
            myRetryRequest.AddRequestVariable("Type", retryType, ECP.EC_Verb.Post);
            const response = await myRetryRequest.Submit();
            ECP.Dialog.HideLoading();
            if (response === "True") {
                ECP.HTML.Snackbar("Success", "Success");
            } else {
                ECP.HTML.Snackbar(response, "Error");
            }
            dialog.style.display = "block";
        };
        const push2em = document.getElementById("push2em");
        if (!EC_Fmt.isNull(push2em)) {
            push2em.addEventListener("click", () => { retryFunction("EM"); });
        }
        document.getElementById("push2email").addEventListener("click", () => { retryFunction("Email"); });
        retryDialog.querySelector(".ecp-dialog-footer").style.minHeight = "8px";
    });

    let result;
    try {
        result = await myRequest.Submit();
    } catch (e) {
        // Sleep
        await new Promise(r => setTimeout(r, 300));
        result = await myRequest.Submit();
    }

    if (result === "True") {
        dialog.querySelector(".ecp-dialog-content").innerHTML = "<center>Succeeded.</center>";
        if (retryDialog) {
            ECP.Dialog.CloseDialog(retryDialog);
        }
        if (dialog) {
            ECP.Dialog.CloseDialog(dialog);
        }
    } else {
        ECP.HTML.Snackbar(result, "Error");
        if (retryDialog) {
            ECP.Dialog.CloseDialog(retryDialog);
        }
        if (dialog) {
            dialog.querySelector(".ecp-dialog-content").innerHTML = `<center>${result}</center>`;
        }
    }
    return result;
};

// eslint-disable-next-line no-var
var EWS = new BC_EWS();

// Remove File NumCompCommon_INC.js
// eslint-disable-next-line no-unused-vars
function NumComp(val) {
    // Task 671357: In the Invoice Edit ,it convert num 1/2 to null
    let result;
    try {
        result = eval(EC_Fmt.CleanNumberStr(val));
    } catch (e) {
        result = val;
    }
    return EC_Fmt.CDec(result);
}

// eslint-disable-next-line no-unused-vars
function Zero2Empty(num) {
    const myNum = EC_Fmt.Null2Zero(num);
    return (myNum === "0") ? "" : myNum;
}

// eslint-disable-next-line no-unused-vars
function SearchURL(Field, val) {
    return encodeURIComponent(`|F:${Field}~V:${val}|`);
}

// eslint-disable-next-line no-unused-vars
function isNumber(val) {
    return EC_Fmt.isNumber(val);
}

// eslint-disable-next-line no-unused-vars
function Null2Zero(val) {
    return EC_Fmt.Null2Zero(val);
}

// Task 550319: Add a 'warning' when the user has caps lock on when typing in a password
// eslint-disable-next-line no-unused-vars
function isCapsLock(PasswordInput) {
    const warnCapsLockElement = document.getElementsByName("warn-capital");

    // Task 614037: Hitting the 'enter' key on the password field for the pop-up log in dialog does not log in the user if the page has other text inputs on it
    PasswordInput.addEventListener("keypress", (event) => {
        // Task 758297: The login page on the iPad browser displays an error
        if (event.getModifierState) {
            const display = event.getModifierState("CapsLock") ? "block" : "none";
            for (let i = 0, len = warnCapsLockElement.length; i < len; i++) {
                warnCapsLockElement[i].style.display = display;
                if (document.getElementById("ecp-logon-tips")) {
                    document.getElementById("ecp-logon-tips").firstChild.style.minHeight = 0;
                }
            }
        }
    });
}

Element.prototype.remove = function () {
    if (this?.parentElement) {
        this.parentElement.removeChild(this);
    }
};

HTMLCollection.prototype.remove = function () {
    for (let i = this.length - 1; i >= 0; i--) {
        if (this[i] && this[i].parentElement) {
            this[i].parentElement.removeChild(this[i]);
        }
    }
};

// Task 598296: iOS Safari can't logon with session expire pop up if you have 2 user records
async function DisplayLogon(message) {
    const myRequest = new ECP.EC_Request("WriteLogon_Guest");
    myRequest.SetAPIToken("33c9305a94a58896fd87f0efd2411380");
    // Task 935369: Users logging in to Encompass get a frozen loading page after entering in their password.
    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
    myRequest.AddRequestVariable("Request", "DialogLogon");
    myRequest.AddRequestVariable("Message", message, ECP.EC_Verb.Post);
    const response = await myRequest.Submit();
    return response;
}
// Task 598296: iOS Safari can't logon with session expire pop up if you have 2 user records
// eslint-disable-next-line no-unused-vars
async function DialogLogon() {
    const form = document.getElementById("LoginForm");

    let username = form.querySelector("#UserNameHidden").value;
    let support = false;

    username = username.toLowerCase().trim();

    if (username.endsWith("$")) {
        username = username.slice(0, -1);
        support = true;
    }

    username = EC_Fmt.MD5(username);

    if (support) {
        username += "$";
    }

    form.querySelector("#Style").value = username;

    ECP.Dialog.ShowLoading();
    ECP.Dialog.CloseDialog(document.getElementById(form.parentElement.parentElement.parentElement.parentElement.parentElement.id));

    const myRequest = new ECP.EC_Request("Logon_Guest");
    myRequest.SetAPIToken("33c9305a94a58896fd87f0efd2411380");
    myRequest.AddRequestVariable("Style", form.querySelector("#Style").value, ECP.EC_Verb.Post);
    myRequest.AddRequestVariable("Theme", form.querySelector("#Theme").value, ECP.EC_Verb.Post);
    myRequest.AddRequestVariable("EncompassID", Distributor, ECP.EC_Verb.Post);
    const result = await myRequest.Submit();
    if (result.status !== "expired" && result.status !== "success") {
        // Task 1166514: Unable to login via MFA if the site has multiple users under the same authentication
        if (result.status === "requireMFA") {
            ECP.Dialog.HideLoading();
            const mfaResult = await EWS.CheckMFAStatus(result.message, result.type, result.token);
            if (mfaResult === "True") {
                result.status = "success";
            } else {
                result.status = "fail";
                result.message = mfaResult;
            }
        } else {
            EWS.Login();
            EWS.VerifySessionFail();
            setTimeout(EWS.Alert(result.message), 250);
        }
    }
    form.style.display = "block";
    ECP.Dialog.HideLoading();
    if (result.status === "success") {
        if (EC_Fmt.isNull(document.getElementsByClassName("Label Right LabelButton")[0])) {
            if (EC_Fmt.isNull(document.getElementById("DestURL").value)) {
                window.location.href = "Home";
            } else {
                window.location.href = document.getElementById("DestURL").value;
            }
        } else {
            document.getElementsByClassName("Label Right LabelButton")[0].innerHTML = result.username;
        }
    }
}

// Task 994583: Allow users to Show/Hide their password in mobile & server login boxes
// eslint-disable-next-line no-unused-vars
function showAndHiddenPassword() {
    const input = document.getElementById("ews-login-password");
    const icon = document.getElementById("passwordIcon");
    if (input.value !== "") {
        if (input.getAttribute("type") === "password") {
            input.setAttribute("type", "text");
            icon.classList.add("ews-icon-eye");
            icon.classList.remove("ews-icon-eyehide");
        } else {
            input.setAttribute("type", "password");
            icon.classList.add("ews-icon-eyehide");
            icon.classList.remove("ews-icon-eye");
        }
    }
}

NodeList.prototype.remove = HTMLCollection.prototype.remove;
